export const handleCopyContent = (content: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard api method's way
    return navigator.clipboard.writeText(content)
  } else {
    // text area method
    const textArea = document.createElement('textarea')
    textArea.value = content
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }
}
export const scrollBodyHide = () => {
  document.body.style.overflow = 'hidden'
}
export const scrollBodyShow = () => {
  document.body.style.overflow = 'auto'
}
